import React, { useState } from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx, useWidgetActions } from '../LayoutContext';
import { ActivityTab } from '../../CaseClient';

// Granular Case-surface widget — wraps the existing ActivityTab. Renders
// the audit-style activity feed for the open case (status changes,
// comments, work-item lifecycle, etc.).

function CaseActivity({ node }) {
  const { token, workspaceId, case: caseRow } = useLayoutCtx();
  const [refreshKey, setRefreshKey] = useState(0);
  useWidgetActions(node?.id, { refresh: () => setRefreshKey(k => k + 1) });

  if (!caseRow?.id) return null;
  return (
    <div style={{ padding: '20px' }}>
      <ActivityTab key={refreshKey} token={token} workspaceId={workspaceId} caseId={caseRow.id} />
    </div>
  );
}

registerWidget({
  type: 'case.activity',
  categories: ['case'],
  palette_label: 'Case activity',
  description: 'Read-only activity feed: status changes, comments, work-item lifecycle, etc.',
  Component: CaseActivity,
  configSchema: null,
  publishes: [],
  subscribes: ['xv.RefreshContext'],
  actions: [
    { name: 'refresh', label: 'Reload activity', description: 'Re-fetches the activity feed from the server.' },
  ],
  group: 'Case',
});
